<wbo-edit-page #editPage [title]="model.data.details.accountName" (addingAnother)="addingAnother($event)">
    <wbo-entity-actions>
        <wbo-entity-action
            *ngIf="editPage.editService.editMode === EditMode.EDIT && model.data.details.accountType.limitDuration"
            [title]="'wbo.account.edit.actions.clearBalance'"
            (click)="clearBalance()"></wbo-entity-action>
        <wbo-entity-action
            *ngIf="model.data.details.priceLevel.priceLevelId"
            [title]="'wbo.account.edit.actions.priceBook'"
            (click)="priceBookReport()"></wbo-entity-action>
        <wbo-entity-action *ngIf="supportsPayment()" [title]="'wbo.account.edit.actions.managePayments'"
                           (click)="managePayments()"></wbo-entity-action>
    </wbo-entity-actions>

    <fui-formation-group-template
        *formationGroup="{title: 'wbo.account.edit.formation.details', formControlNames: ['', 'details']}">
        <fui-rows [formGroup]="editPage.formGroup">
            <ng-container formGroupName="details">
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <fui-append-field>
                                <wbo-text-edit-control formControlName="accountName"
                                                       [(ngModel)]="model.data.details.accountName"></wbo-text-edit-control>
                                <wbo-entity-discontinued-edit-control
                                    formControlName="discontinued"
                                    [(ngModel)]="model.data.details.discontinued"></wbo-entity-discontinued-edit-control>
                            </fui-append-field>
                        </fui-column>
                        <fui-column formGroupName="accountType">
                            <wbo-account-type-single-select-edit-control formControlName="id"
                                                                         [(ngModel)]="model.data.details.accountType.id"
                                                                         [readonlyOnEdit]="true"
                                                                         [objectValue]="model.data.details.accountType"></wbo-account-type-single-select-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                <fui-row>
                    <fui-two-columns>
                        <fui-column *ngIf="editPage.editService.editMode === EditMode.ADD">
                            <fui-prepend-field>
                                <fui-tandem-field>
                                    <ng-container>
                                        <fui-radio-control [(ngModel)]="accountNoAuto" [equivalent]="true"
                                                           [ngModelOptions]="{standalone: true}"
                                                           [label]="'wbo.account.edit.field.auto.label'"></fui-radio-control>
                                        <fui-radio-control [(ngModel)]="accountNoAuto" [equivalent]="false"
                                                           [ngModelOptions]="{standalone: true}"
                                                           [label]="'wbo.account.edit.field.specify.label'"></fui-radio-control>
                                    </ng-container>
                                </fui-tandem-field>
                                <wbo-text-edit-control formControlName="accountNo"
                                                       [(ngModel)]="model.data.details.accountNo"
                                                       [overrideRequired]="!accountNoAuto"
                                                       [readonly]="accountNoAuto"></wbo-text-edit-control>
                            </fui-prepend-field>
                        </fui-column>
                        <fui-column *ngIf="editPage.editService.editMode !== EditMode.ADD">
                            <wbo-text-edit-control formControlName="accountNo"
                                                   [(ngModel)]="model.data.details.accountNo"
                                                   [readonly]="true"></wbo-text-edit-control>
                        </fui-column>
                        <fui-column>
                            <fui-append-field>
                                <wbo-switch-edit-control formControlName="locked"
                                                         [(ngModel)]="model.data.details.locked">
                                </wbo-switch-edit-control>
                                <wbo-checkbox-edit-control formControlName="requiresCustomerReference"
                                                           [(ngModel)]="model.data.details.requiresCustomerReference">
                                </wbo-checkbox-edit-control>
                            </fui-append-field>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                <fui-row>
                    <fui-two-columns>
                        <fui-column formGroupName="priceLevel">
                            <wbo-price-level-single-select-edit-control formControlName="priceLevelId"
                                                                        [(ngModel)]="model.data.details.priceLevel.priceLevelId"
                                                                        [objectValue]="model.data.details.priceLevel"></wbo-price-level-single-select-edit-control>
                        </fui-column>
                        <fui-column formGroupName="discount">
                            <wbo-discount-single-select-edit-control formControlName="discountId"
                                                                     [(ngModel)]="model.data.details.discount.discountId"
                                                                     [objectValue]="model.data.details.discount"></wbo-discount-single-select-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <wbo-numeric-edit-control formControlName="creditLimit"
                                                      [(ngModel)]="model.data.details.creditLimit"
                                                      [readonly]="!(model.data.details.accountType.accountLimited) || isControlsReadonly"></wbo-numeric-edit-control>
                        </fui-column>
                        <fui-column>
                            <wbo-single-select-edit-control formControlName="limitDuration"
                                                            [(ngModel)]="model.data.details.limitDuration"
                                                            [readonly]="!(model.data.details.accountType.limitDuration) || isControlsReadonly">
                                <wbo-account-limit-duration-select-options></wbo-account-limit-duration-select-options>
                            </wbo-single-select-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                <fui-row>
                    <fui-two-columns>
                        <fui-column formGroupName="primaryOutlet">
                            <wbo-outlet-single-select-edit-control formControlName="outletId"
                                                                   [(ngModel)]="model.data.details.primaryOutlet.outletId"
                                                                   [objectValue]="model.data.details.primaryOutlet"></wbo-outlet-single-select-edit-control>
                        </fui-column>
                        <fui-column>
                            <wbo-date-edit-control formControlName="expiry"
                                                   [(ngModel)]="model.data.details.expiry"></wbo-date-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>

                <fui-rows *ngIf="editPage.editService.editMode !== EditMode.ADD"
                         [label]="'wbo.account.edit.formation.balanceSummary'">
                    <div class="manage-payment-button">
                        <fui-commands *ngIf="supportsPayment()" [title]="'wbo.account.edit.actions.managePayments'">
                            <fui-command [title]="'wbo.account.edit.actions.managePayments'"
                                         (clicked$)="managePayments()"></fui-command>
                        </fui-commands>
                    </div>

                    <fui-rows [formGroup]="editPage.formGroup">
                        <fui-row formGroupName="details">
                            <fui-two-columns>
                                <fui-column>
                                    <wbo-currency-edit-control formControlName="currentBalance"
                                                               [(ngModel)]="model.data.details.currentBalance"
                                                               [readonly]="true"></wbo-currency-edit-control>
                                </fui-column>
                                <fui-column>
                                    <wbo-currency-edit-control formControlName="creditAmtTotal"
                                                               [(ngModel)]="model.data.details.creditAmtTotal"
                                                               [readonly]="true"></wbo-currency-edit-control>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>

                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <wbo-date-edit-control label="wbo.account.edit.field.chargeDate.label"
                                                           [ngModelOptions]="{standalone: true}"
                                                           [(ngModel)]="chargeDate"
                                                           [readonly]="true"></wbo-date-edit-control>
                                </fui-column>
                                <fui-column>
                                    <wbo-currency-edit-control label="wbo.account.edit.field.chargeAmt.label"
                                                               placeholder="wbo.account.edit.field.chargeAmt.placeholder"
                                                               [ngModelOptions]="{standalone: true}"
                                                               [(ngModel)]="chargeAmt"
                                                               [readonly]="true"></wbo-currency-edit-control>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                        <fui-row *ngIf="supportsPayment()">
                            <fui-two-columns>
                                <fui-column>
                                    <wbo-date-edit-control label="wbo.account.edit.field.paymentDate.label"
                                                           [ngModelOptions]="{standalone: true}"
                                                           [(ngModel)]="paymentDate"
                                                           [readonly]="true"></wbo-date-edit-control>
                                </fui-column>
                                <fui-column>
                                    <wbo-currency-edit-control label="wbo.account.edit.field.paymentAmt.label"
                                                               placeholder="wbo.account.edit.field.paymentAmt.placeholder"
                                                               [ngModelOptions]="{standalone: true}"
                                                               [(ngModel)]="paymentAmt"
                                                               [readonly]="true"></wbo-currency-edit-control>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                        <fui-row>
                            <fui-two-columns>
                                <fui-column formGroupName="details">
                                    <wbo-date-edit-control formControlName="fromDate"
                                                           [(ngModel)]="model.data.details.fromDate"
                                                           [readonly]="true"></wbo-date-edit-control>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                    </fui-rows>

                </fui-rows>
            </ng-container>
        </fui-rows>

    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.account.edit.formation.contact', formControlNames: 'accountPins'}">
        <fui-rows>
            <fui-row>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.accountPins" [editable]="true"
                                   [removable]="!fromContactEditScreen" [entityPath]="'accountPins'"
                                   (saved)="onSavedAccountPin($event)">
                        <wbo-edit-link-column field="contact.fullName" componentPath="contact"
                                              [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                        <wbo-text-column field="pin" [editable]="true"></wbo-text-column>
                        <wbo-checkbox-column field="defaultContact" [editable]="true"></wbo-checkbox-column>
                        <wbo-edit-grid-add-row [identifierField]="'id'" [componentPath]="'contact'"
                                               *ngIf="!fromContactEditScreen"
                                               (onAfterEntityAdded)="afterEntityAdded($event)">
                            <wbo-edit-grid-add-row-quick-add>
                                <wbo-contact-single-select-edit-control></wbo-contact-single-select-edit-control>
                            </wbo-edit-grid-add-row-quick-add>
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-search
                                    [searchComponent]="ContactSearchPageComponent"></wbo-edit-grid-add-row-search>
                                <wbo-edit-grid-add-row-new-entity
                                    [editComponent]="ContactEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.account.edit.formation.invoicingAndStatements', formControlNames: ['invoiceDetails', 'details.abn']}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row formGroupName="details">
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="abn"
                                               [(ngModel)]="model.data.details.abn"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-rows formGroupName="invoiceDetails" [label]="'wbo.account.edit.field-set.invoicingTerms'">
                <fui-row *ngIf="model.data.hasOpenCharges">
                    <fui-two-columns>
                        <fui-column>
                            <fui-inline-warning [title]="'wbo.common.info.warning'"
                                                [message]="'wbo.account.edit.message.openCharges'"></fui-inline-warning>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <wbo-billing-cycle-single-select-edit-control formControlName="billingCycleDbValue"
                                                                          [(ngModel)]="model.data.invoiceDetails.billingCycleDbValue"
                                                                          [readonly]="model.data.hasOpenCharges"
                                                                          [validBillingCycles]="model.data.details.accountType.validBillingCycles">
                            </wbo-billing-cycle-single-select-edit-control>
                        </fui-column>
                        <fui-column>
                            <wbo-numeric-edit-control formControlName="terms"
                                                      [(ngModel)]="model.data.invoiceDetails.terms"
                                                      [readonly]="model.data.hasOpenCharges"></wbo-numeric-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
            </fui-rows>
            <fui-rows formGroupName="invoiceDetails" [label]="'wbo.account.edit.field-set.invoiceContent'">
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <wbo-statement-address-block-type-single-select-edit-control
                                formControlName="addressBlockTypeDbValue"
                                [(ngModel)]="model.data.invoiceDetails.addressBlockTypeDbValue"
                                [allowClearSelectionOption]="false"></wbo-statement-address-block-type-single-select-edit-control>
                        </fui-column>
                        <fui-column>
                            <wbo-text-edit-control formControlName="termsComment"
                                                   [(ngModel)]="model.data.invoiceDetails.termsComment"></wbo-text-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <wbo-textarea-edit-control formControlName="headerComment"
                                                       [(ngModel)]="model.data.invoiceDetails.headerComment"></wbo-textarea-edit-control>
                        </fui-column>
                        <fui-column>
                            <wbo-textarea-edit-control formControlName="footerComment"
                                                       [(ngModel)]="model.data.invoiceDetails.footerComment"></wbo-textarea-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
                <fui-row>
                    <fui-two-columns>
                        <fui-column>
                            <wbo-textarea-edit-control formControlName="creditFooterComment"
                                                       [(ngModel)]="model.data.invoiceDetails.creditFooterComment"></wbo-textarea-edit-control>
                        </fui-column>
                    </fui-two-columns>
                </fui-row>
            </fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-inline-information [title]="'wbo.common.info.information'"
                                                [message]="'wbo.account.edit.message.statementContent'"></fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row formGroupName="invoiceDetails" [label]="'wbo.account.edit.field-set.issuing'">
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-inverted-checkbox-edit-control formControlName="noStatement"
                                                                [(ngModel)]="model.data.invoiceDetails.noStatement"></wbo-inverted-checkbox-edit-control>
                            <wbo-single-select-edit-control [(ngModel)]="statementIssuedContact"
                                                            [ngModelOptions]="{standalone: true}"
                                                            [allowClearSelectionOption]="false"
                                                            [readonly]="model.data.invoiceDetails.noStatement"
                                                            label="wbo.account.edit.field.invoiceDetails.issueTo.label">
                                <wbo-select-options>
                                    <wbo-select-option [label]="'wbo.account.edit.option.issueTo.primaryContact'"
                                                       [value]="-1"></wbo-select-option>
                                    <wbo-select-option *ngFor="let contact of model.data.accountPins"
                                                       [label]="'\'' + contact.contact.fullName + '\''"
                                                       [value]="contact.accountPinId">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                        </fui-tandem-field>
                        <fui-inline-warning
                            *ngIf="!model.data.invoiceDetails.noStatement && !model.data.details.accountType.issueStatements"
                            [title]="'wbo.common.info.warning'"
                            [message]="'wbo.account.edit.message.noAutomaticStatements'">
                        </fui-inline-warning>
                        <fui-inline-information
                            *ngIf="!model.data.invoiceDetails.noStatement && model.data.details.accountType.issueStatements"
                            [title]="'wbo.common.info.information'"
                            [message]="'wbo.account.edit.message.automaticStatements'"
                            [messageParams]="{'cycle': billingCycleDisplay, 'contact': statementIssuedContactName}">
                        </fui-inline-information>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-inverted-checkbox-edit-control formControlName="noInvoice"
                                                                [(ngModel)]="model.data.invoiceDetails.noInvoice"></wbo-inverted-checkbox-edit-control>
                            <wbo-single-select-edit-control [(ngModel)]="invoiceIssuedContact"
                                                            [ngModelOptions]="{standalone: true}"
                                                            [allowClearSelectionOption]="false"
                                                            [readonly]="model.data.invoiceDetails.noInvoice"
                                                            label="wbo.account.edit.field.invoiceDetails.issueTo.label">
                                <wbo-select-options>
                                    <wbo-select-option [label]="'wbo.account.edit.option.issueTo.primaryContact'"
                                                       [value]="-1"></wbo-select-option>
                                    <wbo-select-option *ngFor="let contact of model.data.accountPins"
                                                       [label]="'\'' + contact.contact.fullName + '\''"
                                                       [value]="contact.accountPinId">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                        </fui-tandem-field>
                        <fui-inline-warning
                            *ngIf="!model.data.invoiceDetails.noInvoice && !model.data.details.accountType.issueInvoices"
                            [title]="'wbo.common.info.warning'"
                            [message]="'wbo.account.edit.message.noAutomaticInvoices'">
                        </fui-inline-warning>
                        <fui-inline-information
                            *ngIf="!model.data.invoiceDetails.noInvoice && model.data.details.accountType.issueInvoices"
                            [title]="'wbo.common.info.information'"
                            [message]="'wbo.account.edit.message.automaticInvoices'"
                            [messageParams]="{'contact': invoiceIssuedContactName}">
                        </fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
